import { DeviceType } from '@/types/navigator.type';
import { MutationTree } from 'vuex';

import {
  SET_AUDIO_CURRENT_DEVICE,
  SET_AUDIO_DEVICES_LIST,
  SET_VIDEO_DEVICES_LIST,
  SET_VIDEO_CURRENT_DEVICE,
  SET_TEXTTOSPEECH_VOICES_LIST,
  SET_TEXTTOSPEECH_CURRENT_VOICE,
  SET_VOLUME,
  CHANGE_IS_CAMERA_LOADING,
  SET_STREAM_CHANGE_COUNT,
  SET_RESOLUTION,
} from './mutationTypes';

import { ResolutionType, StreamState } from './types';

export const mutations: MutationTree<StreamState> = {
  [SET_AUDIO_DEVICES_LIST](state, payload: Array<DeviceType> | null) {
    state.audioDevicesList = payload;
  },

  [SET_AUDIO_CURRENT_DEVICE](state, payload: DeviceType | null) {
    state.audioCurrentDevice = payload;
  },

  [SET_VOLUME](state, payload: number) {
    state.volume = payload;
  },

  [SET_VIDEO_DEVICES_LIST](state, payload: Array<DeviceType>) {
    state.videoDevicesList = payload;
  },

  [SET_VIDEO_CURRENT_DEVICE](state, payload: DeviceType | null) {
    state.videoCurrentDevice = payload;
  },

  [SET_TEXTTOSPEECH_VOICES_LIST](state, payload: Array<DeviceType>) {
    state.textToSpeechVoicesList = payload;
  },

  [SET_TEXTTOSPEECH_CURRENT_VOICE](state, payload: DeviceType | null) {
    state.textToSpeechCurrentVoice = payload;
  },

  [CHANGE_IS_CAMERA_LOADING](state, isLoading: boolean) {
    state['isLoading'] = isLoading;
  },

  [SET_STREAM_CHANGE_COUNT](state, value: number) {
    state.streamChangeCount = value;
  },

  [SET_RESOLUTION](state, data: ResolutionType) {
    state.resolution = data;
  },
};
